import React, { Component } from 'react';


import CleanBarComponent from './../components/ChartCleanBarsDashboard/CleanBarComponent';
import './../../selections/timeSelection/components/timeSelect/cliente.css';

//Actualizacion develop
class CleanBarDB extends Component {

  render() {
    const { data, name, title } = this.props;
    return (
      <CleanBarComponent
        name={name}
        title={title}
        data={data}
        openDialog={this.props.openDialog}
        onClickGraphic={this.props.onClickGraphic}
        seeMore={this.props.seeMore}
        seeRate={this.props.seeRate}
        watchMenu={this.props.watchMenu}
      />
    );
  }
}

export default CleanBarDB;